export default __webpack_public_path__ + "static/media/Avatar.b8aee714.svg";